import styled from 'styled-components';

import Button from 'react-bootstrap/Button';

export const StyledButton = styled(Button)`

`;

export const StyledModalTitle = styled.div`
    padding: 0% 0% 1% 5%;
    font-size: 2rem;
    font-weight: 500;
    opacity: 0.6;
`;

export const StyledPageTitle = styled.div`
    // padding-left: 5%;
    font-size: 3rem;
    font-weight: 800;
`;
